exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".similar-score-card-row{margin:2px 0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /usr/src/sentry/node_modules/css-loader?{"minimize":true}!/usr/src/sentry/node_modules/less-loader/dist/cjs.js!./less/components/similarScoreCard.less
// module id = 1139
// module chunks = 74